import React from "react";
const ListLabel = ({ title, onClick }) => (
    <p onClick={onClick} className="font-bold carbonic shadow-1 cursor-pointer text-center carbonic-card-1 p-2 rounded-1">
        {title}
    </p>
);

export default ListLabel;
